export default __webpack_public_path__ + "images/99ff12d92ee519369b15776cfbb4859a-travel.jpg";